/**
 * items sprite atlas — GENERATED, do not edit.
 *
 *   Blender --background --python tools/blender/build_items.py -- --atlas
 *   Blender --background --python tools/blender/pack_atlas.py -- ...
 *   node tools/build-item-atlas.mjs
 *
 * Frame coordinates into `/items.webp`, rendered from the procedural models in `tools/blender/build_items.py`.
 * One sheet is one request: on a slow connection, separate icons cost far more
 * than the icons' worth of bytes.
 */
export const ATLAS_URL = '/items.webp';
export const ATLAS_CELL = 96;
export const ATLAS_SIZE = { width: 768, height: 672 } as const;

export interface AtlasFrame {
  x: number;
  y: number;
  pool: 'trash' | 'treasure';
}

const FRAMES: Readonly<Record<string, AtlasFrame>> = {
  "crumpled_paper": { x: 0, y: 0, pool: 'trash' },
  "used_tissue": { x: 96, y: 0, pool: 'trash' },
  "cigarette_butt": { x: 192, y: 0, pool: 'trash' },
  "banana_peel": { x: 288, y: 0, pool: 'trash' },
  "apple_core": { x: 384, y: 0, pool: 'trash' },
  "plastic_straw": { x: 480, y: 0, pool: 'trash' },
  "dirty_sock": { x: 576, y: 0, pool: 'trash' },
  "candy_wrapper": { x: 672, y: 0, pool: 'trash' },
  "plastic_fork": { x: 0, y: 96, pool: 'trash' },
  "newspaper": { x: 96, y: 96, pool: 'trash' },
  "chip_bag": { x: 192, y: 96, pool: 'trash' },
  "bottle_cap": { x: 288, y: 96, pool: 'trash' },
  "plastic_cup": { x: 384, y: 96, pool: 'trash' },
  "face_mask": { x: 480, y: 96, pool: 'trash' },
  "plastic_bottle": { x: 576, y: 96, pool: 'trash' },
  "milk_carton": { x: 672, y: 96, pool: 'trash' },
  "coffee_cup": { x: 0, y: 192, pool: 'trash' },
  "egg_carton": { x: 96, y: 192, pool: 'trash' },
  "soda_can": { x: 192, y: 192, pool: 'trash' },
  "pizza_box": { x: 288, y: 192, pool: 'trash' },
  "glass_bottle": { x: 384, y: 192, pool: 'trash' },
  "old_shoe": { x: 480, y: 192, pool: 'trash' },
  "broken_toy": { x: 576, y: 192, pool: 'trash' },
  "broken_umbrella": { x: 672, y: 192, pool: 'trash' },
  "torn_backpack": { x: 0, y: 288, pool: 'trash' },
  "silver_coin": { x: 96, y: 288, pool: 'treasure' },
  "gold_coin": { x: 192, y: 288, pool: 'treasure' },
  "ancient_coin": { x: 288, y: 288, pool: 'treasure' },
  "pearl": { x: 384, y: 288, pool: 'treasure' },
  "silver_bar": { x: 480, y: 288, pool: 'treasure' },
  "jade": { x: 576, y: 288, pool: 'treasure' },
  "gold_bar": { x: 672, y: 288, pool: 'treasure' },
  "emerald": { x: 0, y: 384, pool: 'treasure' },
  "ruby": { x: 96, y: 384, pool: 'treasure' },
  "vip_card": { x: 192, y: 384, pool: 'treasure' },
  "crystal": { x: 288, y: 384, pool: 'treasure' },
  "designer_bag": { x: 384, y: 384, pool: 'treasure' },
  "diamond_ring": { x: 480, y: 384, pool: 'treasure' },
  "diamond": { x: 576, y: 384, pool: 'treasure' },
  "luxury_watch": { x: 672, y: 384, pool: 'treasure' },
  "magic_crystal": { x: 0, y: 480, pool: 'treasure' },
  "golden_trophy": { x: 96, y: 480, pool: 'treasure' },
  "golden_crown": { x: 192, y: 480, pool: 'treasure' },
  "royal_scepter": { x: 288, y: 480, pool: 'treasure' },
  "golden_statue": { x: 384, y: 480, pool: 'treasure' },
  "rare_painting": { x: 480, y: 480, pool: 'treasure' },
  "treasure_chest": { x: 576, y: 480, pool: 'treasure' },
  "car_key": { x: 672, y: 480, pool: 'treasure' },
  "ancient_relic": { x: 0, y: 576, pool: 'treasure' },
  "phoenix_gem": { x: 96, y: 576, pool: 'treasure' },
};

/**
 * Frame for a key, or null when the sheet has no art for it.
 *
 * Null rather than a placeholder frame is deliberate: something added before
 * its model is rendered should fall back to its emoji, not draw whatever
 * happens to sit at (0, 0).
 */
export function atlasFrame(key: string): AtlasFrame | null {
  return FRAMES[key] ?? null;
}

export const ATLAS_KEYS = Object.keys(FRAMES);
